import type { OptionalDealerId } from '@oneaudi/dealer-context-service';

type BrandIdentifier = 'A' | 'C' | 'E' | 'G' | 'L' | 'M' | 'N' | 'P' | 'S' | 'V';

export const parsePartnerId = (partnerId: string): OptionalDealerId => {
  if (partnerId.length < 5) {
    throw new Error('Invalid code. Must be at least 5 characters long.');
  }

  const market = partnerId.slice(0, 3);
  const brand = partnerId[3] as BrandIdentifier;
  const id = partnerId.slice(4);

  return { brand, id, market };
};
